export default "__VITE_PUBLIC_ASSET__53c8fbb5__"